import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { KPI } from "@/types/kpiTypes.ts"

type KPIValuesQuery = {
  locationId?: number
  typeId?: number
  returnSize?: number
}

export const getKPIValues = async (id: number, query: KPIValuesQuery): Promise<KPI> => {
  const { data, error, response } = await apiClient.GET("/api/KPIs/{kpiId}/values", {
    params: {
      path: { kpiId: id },
      query: {
        LocationId: query.locationId,
        TypeId: query.typeId,
        ReturnSize: query.returnSize,
      },
    },
  })
  return assertOk(response, error, data)
}
